import { render, staticRenderFns } from "./large-payout-approval.vue?vue&type=template&id=bc3fb53a&scoped=true"
import script from "./large-payout-approval.vue?vue&type=script&lang=js"
export * from "./large-payout-approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3fb53a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3fb53a')) {
      api.createRecord('bc3fb53a', component.options)
    } else {
      api.reload('bc3fb53a', component.options)
    }
    module.hot.accept("./large-payout-approval.vue?vue&type=template&id=bc3fb53a&scoped=true", function () {
      api.rerender('bc3fb53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/large-payout-approval.vue"
export default component.exports